<div
   class="session-banner"
   *ngIf="minutesBeforeExpiration >= 0 && minutesBeforeExpiration <= warningMinutes">
   Your session will expire in {{ minutesBeforeExpiration }} minute{{ minutesBeforeExpiration !== 1 ? 's' : '' }}.
   Please save your work and then &nbsp;
   <button (click)="extendSession()">click here</button>
   &nbsp; to extend your session.
</div>
